"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AppFrame_styles_1 = require("./AppFrame.styles");
var AppFrame_classNames_1 = require("./AppFrame.classNames");
var Error_1 = require("./Error");
var AppFrame = /** @class */ (function (_super) {
    __extends(AppFrame, _super);
    function AppFrame(props) {
        var _this = _super.call(this, props) || this;
        _this._onMessage = function (e) {
            if (e.origin && e.source === _this._frameRef.contentWindow && _this.props.messageRouter) {
                _this.props.messageRouter.handleRequest(e.data).then(function (value) {
                    e.source.postMessage({ correlationId: e.data.correlationId, value: value }, "*");
                }).catch(function (error) {
                    try {
                        e.source.postMessage({
                            correlationId: e.data.correlationId,
                            error: error
                        }, "*");
                    }
                    catch (e) {
                        e.source.postMessage({
                            correlationId: e.data.correlationId,
                            error: { message: "Error processing message", details: JSON.stringify(error) }
                        }, "*");
                    }
                });
            }
        };
        _this._onResize = function () {
            var bounds = _this._containerRef.getBoundingClientRect();
            if (_this._frameRef) {
                _this._frameRef.width = String(bounds.width);
                _this._frameRef.height = String(bounds.height);
            }
            if (!_this.state.renderFrame && bounds.width > 0 && bounds.height > 0) {
                _this.setState({ renderFrame: true });
            }
        };
        _this._onContainerRef = function (ref) {
            _this._containerRef = ref;
        };
        _this._onFrameRef = function (ref) {
            _this._frameRef = ref;
            if (_this._frameRef) {
                _this._onResize();
            }
        };
        _this._onFrameLoaded = function (e) {
            try {
                _this._frameRef.contentWindow.addEventListener("message", _this._onMessage);
            }
            catch (e) {
                _this.setState({ error: e });
                console.error(e);
            }
        };
        _this.state = { renderFrame: false };
        return _this;
    }
    AppFrame.prototype.componentDidMount = function () {
        var host = this.props.host;
        if (host) {
            host.addEventListener("resize", this._onResize);
            this._onResize();
        }
    };
    AppFrame.prototype.componentWillUnmount = function () {
        if (this.props.host) {
            this.props.host.removeEventListener("resize", this._onResize);
        }
        if (this._frameRef) {
            this._frameRef.removeEventListener("load", this._onFrameLoaded);
            if (this._frameRef.contentWindow) {
                try {
                    this._frameRef.contentWindow.removeEventListener("message", this._onMessage);
                }
                catch (e) {
                    console.error(e);
                }
            }
            this._frameRef.src = "about:blank";
        }
    };
    AppFrame.prototype.render = function () {
        var classNames = AppFrame_classNames_1.getClassNames(AppFrame_styles_1.getStyles(undefined, this.props.styles), this.props.className);
        var frame = this.state.renderFrame ?
            React.createElement("iframe", { className: classNames.frame, ref: this._onFrameRef, src: this.props.src, onLoad: this._onFrameLoaded }) : undefined;
        var error = this.state.error ?
            React.createElement(Error_1.Error, { error: this.state.error }) : undefined;
        return (React.createElement("div", { className: classNames.root, ref: this._onContainerRef },
            frame,
            error));
    };
    return AppFrame;
}(React.Component));
exports.AppFrame = AppFrame;
;
